import { render, staticRenderFns } from "./InformationDetails.vue?vue&type=template&id=676783f6&scoped=true&"
import script from "./InformationDetails.vue?vue&type=script&lang=js&"
export * from "./InformationDetails.vue?vue&type=script&lang=js&"
import style0 from "./InformationDetails.vue?vue&type=style&index=0&id=676783f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676783f6",
  null
  
)

export default component.exports